import {WorkflowInstanceStepEditModel} from "./workflow-instance-step-edit.model";
import {WorkflowStep} from "../../../enums/WorkflowStep";
import {WorkflowStepLibraryAgilantModel} from "../workflow-step-library-agilant.model";
import {BatchModel} from "../../batch/batch.model";
import {WorkflowStepLibraryIndexPurificationModel} from "../workflow-step-library-index-purification.model";

export class WorkflowInstanceStepLibraryIndexPurificationEditModel extends WorkflowInstanceStepEditModel {

  batches: BatchModel[];
  fileId: number;

  static initFromStep(step: WorkflowStepLibraryIndexPurificationModel): WorkflowInstanceStepLibraryIndexPurificationEditModel {
    const ret = new WorkflowInstanceStepLibraryIndexPurificationEditModel();
    ret.workflowStep = WorkflowStep.INDEX_PURIFICATION;
    ret.workflowInstanceStepId = step.id;
    ret.fileId = step.file?.id;
    ret.batches = step.batches.filter(BatchModel.isValid);
    return ret;
  }

}
